import React from "react";
// import { NavItem, NavLink, Nav } from "reactstrap";
import classNames from "classnames";
import './style.scss'

const SCENE_NAMES = [
  'Intro', 'Lobby', 'War Room', 'Area 2'
];

const SideBar = ({ isOpen, changeScene, openInfoSpot }) => {
  return (
    <div className={classNames("sidebar", { "is-open": isOpen })} style={{ height: (window.innerHeight - 87) + "px" }} id="sidebar1">
      <div className="ml-5 sidebar-content">
        <h6 className="sidebar-heading mt-4">Scenes</h6>
        {SCENE_NAMES.map((name, i) => (
          <p
            key={i}
            onClick={() => changeScene(i)}
            className="route-to-experience route-to-infospot mt-2"
          >
            {name}
          </p>
        ))}
      </div>
    </div>
  );
};


export default SideBar;
